import type { SalesAction } from '@shared/types/sales-action';

/// 判定に必要な最小フィールドだけを受ける (テスト容易性のため)。
type ContractLinkView = Pick<
  SalesAction,
  'sales_status' | 'action_status' | 'linked_contract_id'
>;

/**
 * 受注済み・契約未作成 (won_contract_missing)。 保存ステータスではなく、
 * 既存の `linked_contract_id` が空かどうかから導出する派生状態。
 * 表示ラベルは「契約未作成」。 結果タブ・契約タブの判定はこの helper に寄せ、
 * 画面ごとに重複実装しない。
 */
export function needsContractCreation(action: ContractLinkView): boolean {
  return (
    action.sales_status === 'won' &&
    action.action_status === 'completed' &&
    action.linked_contract_id === null
  );
}
